import { getMessaging, getToken, onMessage } from "firebase/messaging";
import axios from 'axios';
import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import firebaseConfig, { VAPID_KEY } from "./config/firebaseConfig";

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
export const auth = getAuth(app);
export { RecaptchaVerifier, signInWithPhoneNumber };

/**
 * Get Firebase Cloud Messaging token and save it to server
 * @param {Function} setTokenFound - Callback to set token found state
 * @param {string|number} userId - User ID from Redux state (user?.user?.id)
 * @param {Object} pubnub - Optional PubNub instance (currently unused)
 */
export const getMes = (setTokenFound, userId, pubnub) => {
  getToken(messaging, { vapidKey: VAPID_KEY })
    .then((currentToken) => {
      if (currentToken) {
        setTokenFound(true);
        // Send the token to your server
        if (userId) {
      
          // Get token from authState stored in localStorage
          let authToken = null;
          const authState = localStorage.getItem("authState");
          if (authState) {
            try {
              const parsedAuth = JSON.parse(authState);
              authToken = parsedAuth?.user?.token;
            } catch (error) {
            }
          }

          const config = {
            method: 'post',
            // url: `${process.env.REACT_APP_URL}/notifications/device`,
            url: `${process.env.REACT_APP_BASE_URL}/api/notification-service/notifications/device`,
            data: {
              // firebasetoken: currentToken,
              // device_type: "web",
              // user_uuid: userId,
              platform: "web",
              device_token: currentToken
            },
            headers: {
              ...(authToken && { 'Authorization': `Bearer ${authToken}` })
            }
          };

          axios(config)
            .then((resp) => {
            })
            .catch((err) => {
            });
        } else {
        }
      } else {
        setTokenFound(false);
      }
    })
    .catch((err) => {
      setTokenFound(false);

      // Common error handling
      if (err.code === 'messaging/permission-blocked') {
      } else if (err.code === 'messaging/permission-default') {
      } else if (err.code === 'messaging/unsupported-browser') {
      }
    });
};

/**
 * Listen for foreground messages (when app is open)
 * @returns {Promise} Promise that resolves with the message payload
 */
export const onMessageListener = () => {
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
};
